import { render, staticRenderFns } from "./NewsCategoryBase.vue?vue&type=template&id=12f94c48&scoped=true"
import script from "./NewsCategoryBase.vue?vue&type=script&lang=js"
export * from "./NewsCategoryBase.vue?vue&type=script&lang=js"
import style0 from "./NewsCategoryBase.vue?vue&type=style&index=0&id=12f94c48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f94c48",
  null
  
)

export default component.exports